module.exports = __webpack_public_path__ + "static/img/app-slide-show2.734cff5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/client/cjpublishing-swfl-wgm/images/app-slide-show2.png
// module id = 6hTQ
// module chunks = 44